import React, { Component } from 'react'
import { Link } from 'react-router-dom'

class CategoriesShowcaseCustom extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return (
      <div className='bx-showcase-categories-custom pos-relative pb-3 px-2 px-md-1 scope-points'>
        <div className='container px-0'>
          <div className='row'>
            <div className='col-12 mb-2'>
              <h2 className='txt-font-title color-title'>Que tal então procurar por categoria?</h2>
            </div>
            <div className='col-12 px-0 px-md-1'>
              <div className='row mx-md-0'>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/categories'><i className='icon icon_gift icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/categories'>Todas</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=3'><i className='icon icon_baby icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=3'>Bebês</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=4'><i className='icon icon_beauty icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=4'>Saúde e beleza</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=8'><i className='icon icon_ruler icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=8'>Moda</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=2'><i className='icon icon_car icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=2'>Automotivo</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=6'><i className='icon icon_phone icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=6'>Eletrônicos</Link></p>
                    </div>
                  </div>
                </div>
                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=5'><i className='icon icon_pan icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=5'>Casa e cozinha</Link></p>
                    </div>
                  </div>
                </div>

                <div className='category-item col-6 col-md-3 bg-white py-3 py-md-5'>
                  <div className='row align-items-center h-100  py-3'>
                    <div className='col-auto mx-auto'>
                      <Link to='/search?category=13'><i className='icon icon_drink icon-lg' /></Link>
                    </div>
                    <div className='col-12 mt-1'>
                      <p className='txt-center txt-title'><Link to='/search?category=13'>Gastronomia</Link></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default CategoriesShowcaseCustom



// WEBPACK FOOTER //
// ./src/Catalog/Showcase/CategoriesShowcaseCustom.js